/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import Link from '@nmx/template/dist/componentLibrary/components/Link';

export const LinkButtonStyled = styled(Link)`
  margin-top: ${rem(24)};
`;

